/* ==========================================================================
   FUNDRAISING-V2 — Purchase-path failsafe.
   Additive, new asset. Loaded via one marked line in layout/theme.liquid.
   - Blocks any submit / fetch / XHR to /cart/add.
   - On the /cart page, hides contents and shows the "Coming soon" notice.
   No dependencies. Changes nothing else on the site.
   ========================================================================== */
(function () {
  'use strict';

  var NOTICE_HTML =
    '<div class="rte" style="max-width:62rem;margin:4rem auto;text-align:center;' +
    'border:0.1rem solid rgba(var(--color-foreground),0.30);' +
    'border-radius:var(--buttons-radius,0.4rem);padding:2.4rem;">' +
    '<p><strong>Coming soon — we’re in our fundraising phase.</strong></p>' +
    '<p>Alexander Bingel is not taking orders yet. Nothing on this site can ' +
    'currently be bought, pre-ordered, or reserved. We’re raising the funds ' +
    'needed for our first production run. If you’d like to help us get there, ' +
    'you can support us with a voluntary donation on our fundraising page.</p></div>';

  // 1) Block form submissions to /cart/add
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.getAttribute && /\/cart\/add/.test(form.getAttribute('action') || '')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // 2) Block fetch() calls to /cart/add. Returns a Dawn-native 422 JSON response
  //    (not a rejection) so nothing throws an uncaught error in the console.
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && /\/cart\/add/.test(url)) {
        var payload = {
          status: 422,
          message: 'Not available',
          description: 'We’re in our fundraising phase — nothing is for sale yet.'
        };
        return Promise.resolve(new Response(JSON.stringify(payload), {
          status: 422,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      return _fetch.apply(this, arguments);
    };
  }

  // 3) Block XHR calls to /cart/add
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__fv2Blocked = !!(url && /\/cart\/add/.test(url));
      return _open.apply(this, arguments);
    };
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__fv2Blocked) { return; }
      return _send.apply(this, arguments);
    };
  }

  // 4) On the cart page, hide contents and show the notice
  function handleCartPage() {
    if (window.location.pathname.indexOf('/cart') !== 0) { return; }
    document.documentElement.classList.add('fundraising-v2-cart-blocked');
    var main = document.querySelector('#MainContent, main, [role="main"]');
    if (main && !document.querySelector('.fundraising-v2-cart-notice')) {
      var wrap = document.createElement('div');
      wrap.className = 'fundraising-v2-cart-notice page-width';
      wrap.innerHTML = NOTICE_HTML;
      main.insertBefore(wrap, main.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleCartPage);
  } else {
    handleCartPage();
  }
})();
